import flagKeys from '@/constants/flagKeys';
import IntegrationsManagment from '@/views/Settings/Apps.vue';
import { Route } from '../route.model';

const integrations = new Route(
  '/settings/apps',
  'settings-apps',
  IntegrationsManagment,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    onlyManager: true,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Integrations', // TODO apply i18n
      icon: 'integrations'
    },
    pageView: {
      eventLabel: 'Integrations'
    }
  }
);

export { integrations };
export default integrations;
